"use strict";
const currentYear = new Date().getFullYear();
const en = {
    ImportantNotice: "Important Notice",
    TransferPromoDisclaimer: "Please note that Promos / Bonus is only for certain game products. Violation of bonus T&C will cause any winning being cancelled.",
    TrustSecurityTitle: "Security",
    TrustSecurityDesc: "Multi-layer protection",
    TrustPrivacyTitle: "Privacy",
    TrustPrivacyDesc: "Protecting your info",
    TrustFairTitle: "Fair Play",
    TrustFairDesc: "Officially licensed",
    TrustSupportTitle: "24/7 Support",
    TrustSupportDesc: "Professional team",
    AlwaysAvailable: "Always available",
    NoPromotionsFound: "No promotions in this category yet.",
    BackToHome: "Back to Home",
    WelcomeBack: "Welcome Back!",
    LoginContinueJourney: "Log in to pick up where you left off.",
    EnterYourUsername: "Enter your username",
    EnterYourPassword: "Enter your password",
    ShowPassword: "Show password",
    Or: "or",
    NoAccountYet: "Do not have an account yet?",
    Click: "Click",
    CreateYourAccount: "Create Your Account",
    JoinStartJourney: "Join us and start your journey today.",
    StepAccountSetup: "Account Setup",
    StepPersonalInformation: "Personal Information",
    StepDone: "Done",
    AffiliateReferralId: "Affiliate ID / Referral ID",
    Optional: "(Optional)",
    EmailAddress: "Email Address",
    MobileNumber: "Mobile Number",
    DateOfBirth: "Date of Birth",
    SelectYourBank: "Select your bank",
    HowDoYouKnowUs: "How do you know us?",
    UsernameHint: "6-13 characters, letters and numbers only",
    PasswordHint: "6-12 characters, letters and numbers only",
    ConfirmPasswordHint: "Please re-enter your password",
    TermsConsentStep1: "By clicking NEXT, I confirm that I am above 18 years old and have read and agree to the",
    TermsConsentStep2: "By clicking the Register button, I hereby acknowledge that I am above 18 years old and have read and accepted your",
    SecureNote: "Your information is safe and secure with us.",
    BackToAccountSetup: "Back to Account Setup",
    AlreadyHaveAccount: "Already have an account?",
    RPALERT_ENTER_SOCIALID: "Please enter Social Media ID",
    RPALERT_ENTER_REMARKS: "Please enter Remarks",
    Congratulations: "Congratulations!",
    RegistrationSuccessful: "Registration Successful!",
    RegistrationSuccessCopy: "Your account has been created successfully. Let the fun begin!",
    YourAccountDetails: "Your Account Details",
    NeedHelp: "Need Help?",
    NeedHelpCopy: "Contact our 24/7 customer support anytime.",
    LiveTransactionDeposit: "Live Transaction Deposit",
    LiveTransactionWithdrawal: "Live Transaction Withdrawal",
    LuckyPickSlots: "Lucky Pick Slots",
    FastGames: "Fast Games",
    GameUploadSlider: {
        TopCasinoTitle: "Top Live Casino",
        TopSlotTitle: "Most played of the month",
    },
    WithdrawalPage: {
        ImportantNotice: "Important Notice",
        ShowLess: "Show Less",
        IM1: "Kindly check with our <b>24/7 LIVECHAT</b> if your transaction is pending for more than 10 minutes.",
        IM2: "Withdrawal bank account name must match with registered full name; member is not allowed to withdraw to a 3rd party bank account.",
        IM3: "Some game providers require 15–30 minutes of report sync time, kindly bear with us during the required sync time.",
        IM4: "Please make sure your turnover requirement has been achieved before making a withdrawal transaction to avoid inconvenience.",
        IM5: "If there is any discrepancy or if you have any further withdrawal inquiries, kindly contact our <b>24/7 LIVECHAT</b>. Thank you.",
    },
    PromotionPage: {
        JustForYouBannerTitle: "Stay tuned, more bonuses are coming!",
        Just4UHeaderTitle: "Just For You"
    },
    CustomBannerSliderTitle: "Latest Updates",
    DepositOptions: "Deposit Options",
    WebVersion: "Web Version",
    WinloseAmt: "Winlose Amount",
    Free: "Free",
    InvitationAcception: "Invitation Acception",
    Message: "Message",
    Referral: "Referral",
    Profile: "Profile",
    MyProfile: "My Profile",
    AffReferralTNC1: "Friends registered through your unique refer link/ID will be entitled [CURRENCY] [REWARDAMT].",
    AffReferralTNC2: "You will receive a [CURRENCY] [REWARDAMT] bonus reward for every referral made as long as your referee fulfils a registration.",
    AffShareHappinessMsg: 'Welcome to [COMPANYNAME]! Your friend has invited you to join the fun at [COMPANYNAME]. Click on the link below and enjoy [CURRENCY] [BONUSAMT] when you deposit MYR [DEPOSITAMT] now! We can’t wait to share exciting offers with you.',
    AffShareOfferTitle: 'Share your favourite offers to your friends!',
    AffShareHapinessTitle: 'Share Happiness with Your Friend',
    AffShareHapinessDesc: 'Get exclusive referral bonuses when your friend signs up using your referral code.',
    YourReferralStatus: "Your Referral Status",
    InviteFriend: "Invite Friend",
    ReferralLink: "Referral Link",
    FullName: "Full Name",
    NoFileChosen: "No File Chosen",
    voucher: "Voucher",
    MyReferral: "My Referral",
    MyBonus: "My Bonus",
    ProductTabContent: {
        SportHeaderTitle: 'Sports',
        SportHeaderDesc: 'Best odds with more than 35,000 live matches.',
        SlotHeaderTitle: 'Slot Games',
        SlotHeaderDesc: 'Most comprehensive and the hottest slot games.',
        CasinoHeaderTitle: 'Live Casino',
        CasinoHeaderDesc: 'Most comprehensive and the hottest live casino.',
        FishHeaderTitle: 'Fishing',
        FishHeaderDesc: 'Your favorite fishing games are here.',
        MobileHeaderTitle: 'EGames',
        MobileHeaderDesc: 'Super Slot That Is Easy To Win',
        HotGamesHeaderTitle: 'New Hot Games',
        HotGamesHeaderDesc: 'Choose your favorite provider!'
    },
    ProductPage: {
        SportHeaderTitle: 'Choose your favorite provider!',
        CasinoHeaderTitle: 'Exciting Live Casino games!',
        SlotHeaderTitle: 'Choose your favorite provider!',
        LotteryHeaderTitle: 'Strike it big with lottery!',
        FishingHeaderTitle: 'Your favorite fishing games are here',
        MobileHeaderTitle: 'Super Slot That Is Easy To Win',
        Lottery4DHeaderTitle: 'Fastest & highest 4D lottery payout in the market',
        CockFightHeaderTitle: 'Awesome fight games!',
        CricketHeaderTitle: 'Awesome cricket games!'
    },
    COOLDOWN_MINUTE_60: "Reset ID can only be done 1 time per hour. Please try again later",
    COOLDOWN_HOUR_24: "Reset ID can only be done 1 time per daily. Please try again later",
    ConfirmationResetID: "If you wish to reset ID, you will not be able to obtain your old ID. Would you like to change to new ID ?",
    ResetID: "Reset ID",
    HAS_CREDIT: "Transfer your balance to main wallet with reset ID",
    ResetGameId: {
        SuccessWithBalance: 'Your credit has been successfully transferred to the main wallet and your ID has been reset. Good Luck.',
        Success: 'Your ID has been successfully reset. Good Luck.',
    },
    PersonalInformation: "Personal Information",
    CurrentPassword: "Current Password",
    NewPassword: "New Password",
    ConfirmNewPassword: "Confirm New Password",
    Preview: "Preview",
    ResetInDays: "Reset In Days",
    S88Pay: 'S88Pay',
    livetransaction: "**LIVE TRANSACTION",
    LuckySpin: "Lucky Spin",
    LuckyBox: "Lucky Box",
    Plinko: "Plinko",
    luckyspin_lexin: "LEX SPIN",
    AffiliateLinkInfo: "Affiliate Info",
    OKContinue: "Please click OK to continue.",
    PleaseTopup: "Please topup to get your rewards.",
    PressRefreshAfterPlay: "Press refresh after play",
    Example: "Example",
    InvalidPassword: "Invalid Password.",
    BirthdayReward: "Birthday Reward",
    Close: "Close",
    CashRebateReward: "Cash Rebate Reward",
    LuckySpinReward: "Lucky Spin Reward",
    DailyLoginReward: "Daily Login Reward",
    PlayerRegisterReward: "Player Register Reward",
    ForgotPIN: "Reset PIN",
    Guide: "Guide",
    PleaseEnterPIN: "Please enter PIN.",
    PleaseSetupPIN: "Please setup your PIN.",
    PIN_6DIGIT: "Please enter 6 digits PIN.",
    PIN_NOT_MATCH: "PIN not match, please re-enter PIN.",
    INVALID_PIN: "Invalid PIN.",
    PIN: "Enter PIN",
    RePIN: "Re-enter PIN",
    days: 'day(s)',
    hours: 'hour(s)',
    minutes: 'minute(s)',
    Remaining: 'Remaining',
    RemainingTime: 'Remaining Time',
    VoucherEmptyMsg: "We 're sorry, there is no voucher available at the moment.",
    StartIn: 'Start In',
    BonusQuantityExceeded: 'All bonus has been redeemed, please select other package.',
    AboutUs: "About Us",
    InfoCentre: "Info Centre",
    Details: "Details",
    ApplyNow: 'Apply Now',
    ClaimNow: 'Claim Now',
    Claimed: 'Claimed',
    InformationCentre: "Information Centre",
    MostPlayedMonth: "Most played of the month",
    TopLiveCasino: "Top Live Casino",
    YoutubeVideos: "Youtube Videos",
    PopularSlotGames: "Popular Slot Games",
    Monthly: "Monthly",
    Rank: "Rank",
    Turnover: "Turnover",
    Prizes: "Prizes",
    PrizeName: "Prize Name",
    PrizeInfo: "Prize Info",
    Month: "Month",
    Year: "Year",
    Search: "Search",
    ReadNext: "Read Next",
    Rewards: "Rewards",
    WinOver: "Winover",
    Rollover: "Rollover",
    Retrieve: "Retrieve",
    Form: {
        RememberMe: "Remember Me"
    },
    GameProviderTitle: {
        DG855: "DREAM GAMING",
        BBINLC: "BBIN",
        EvoGaming: "EVOLUTION",
        WanMeiLC: "WM",
        SexyBac: "SEXY GAMING"
    },
    MoreApplications: "More applications",
    LessApplications: "Less applications",
    AutoTransfer: "Auto Transfer",
    Multiplier: "Multiplier",
    eSports: "eSports",
    HotMatches: "Hot Matches",
    ContactUs: "Contact Us",
    RegionAndLanguage: "Region and Language",
    Language: "Language",
    Remarks: 'Remarks',
    RP_ALERT_USERID_EXIST: 'Username already exists',
    Register: 'Register',
    AccountName: "Account Name",
    BankAccountName: "Account Name",
    BankAccountNumber: "Account No",
    TransferTo: "Transfer To",
    TransferFrom: "Transfer From",
    CopyAccountNumber: "Copy Account No",
    Copy: "Copy",
    Copied: "Copied",
    Share: 'Share',
    QuickDeposit: "Quick Deposit",
    QuickDepositNotice1: "To deposit, only use the account that has been registered with us.",
    QuickDepositNotice2: "Deposit like this, no need to submit a notification form on the website.",
    QuickDepositNotice3: "After Bank Transfer please send bank slip to customer services at livechat.",
    Amount: "Amount",
    Exchange: "Exchange",
    ExchangeRate: "Exchange Rate",
    YouWillReceive: "You Will Receive",
    ATM: "ATM Transfer",
    AccessRestricted: "Access Restricted",
    AccountInfo: "Account Info",
    Back: "Back",
    AffiliateUpline: 'Affiliate Upline',
    AffTitle: 'Share QR Code to friend to get commission',
    Receipt: "Receipt",
    Initiated: "Initiated",
    Accepted: "Accepted",
    Rejected: "Rejected",
    Error: "Error",
    Processing: 'Processing',
    Fund: 'Funds',
    QuickPay: 'PayTrust',
    AccountNameIsNull: "The Account Name Is Needed",
    AccountNoIncorrect: "The Account No Is Not Valid",
    AccountNoIsEmpty: "The Account No Is Needed",
    AccountSuccessfulCreate: "Account Successful Created",
    AcctNameIncorrect: "The Account Name Is Invalid",
    AccountNumber: "Account Number",
    BSBNo: "BSB Number",
    PayID: "Pay ID",
    Activate: "Activate",
    Adjustment: "Adjustment",
    AdjustmentDeposit: "Manual Bonus Adjustment",
    AdjustmentWithdraw: "Fraud Amount Deduction",
    AdjNoPay: "No Pay (Waived)",
    Affiliate: "Affiliate",
    AffiliateRef: "Affiliate",
    AffiliateQR: "Affiliate QR",
    AffReport: "Affiliate Report",
    AffProgram: "Referral Program",
    Placeholder_Affiliate: 'Affiliate ID / Referral ID',
    Placeholder_AffiliateOptional: "(Leave it blank if you don't have a refferer)",
    Reg_Form_Optional: "Optional if available",
    All: "All",
    AllGames: "All Games",
    AmountNotCorrect: "Invalid Amount",
    Android: "Android",
    AnnouncementInfo1: "",
    AnnouceInfo2: "",
    Approved: "Approved",
    Arcades: "Arcades",
    AreYouSure: "Are you sure?",
    Attachment: "Attachment",
    AGENT_SCORE_NOT_ENOUGH_CREDIT: "Agent score not enough, kindly contact customer service",
    BRANCH: "Branch",
    BROWSER_BLOCKED_POPUP: "Browser Blocked Popup",
    Balance: "Balance",
    Bank: "Bank",
    BankDetails: "Bank Details",
    BankInTime: "Date & Time",
    BarcodeClickHere: "2D Barcode Click Here >>>",
    BettingCasino: "Betting (Live Casino)",
    BettingEGames: "Betting (EGames)",
    Banking: 'Banking',
    Others: 'Others',
    WelcomeBonus: 'Welcome Bonus',
    BettingLottery: "Betting (Lottery)",
    BettingMSport: "Betting (M Sport)",
    BettingP2P: "Betting (P2P)",
    BettingSport: "Betting (Sport)",
    BetNow: "Bet Now",
    Bonus: "Bonus",
    FishHunt: 'Fishing',
    CashFish: 'Cash Fish',
    CDM: "Cash Deposit",
    CFSupportDesktopOnly: "Only Support PC",
    CITY: "City",
    CT_LOADING: "Loading...",
    Cancel: "Cancel",
    Captcha: "Captcha",
    ChangeLanguage: "Change Language",
    ChangePassword: "Change Password",
    ConfirmContinue: "Are you sure want to continue?",
    ConfirmPassword: "Confirm Password",
    Contact: "Contact",
    CopyUrlLink: "Copy Url Link",
    Copyright: "Copyright",
    CopyrightText: "Copyright [COMPANYNAME] © [YEAR]. All rights reserved.",
    Currency: "Currency",
    CurrentStatus: "Current Status",
    CurrentDeposit: "Current Deposit",
    AmountRequiredForNextTierUpgrade: "AMOUNT REQUIRED FOR NEXTTIER UPGRADE",
    DepositLesserThan: "DEPOSIT LESSER THAN",
    Date: "Date",
    DOB: "Date Of Birth",
    Daily: 'Daily',
    RegisterDesc1: 'Do not have an account yet? Click',
    RegisterDesc2: 'to register',
    DateFromInvalid: "First date must be greater than second date",
    DateToInvalid: "Second date must be greater than first date",
    Deposit: "Deposit",
    DepositNow: "Deposit Now",
    DepositACCTNAME: "Account Name",
    DepositAmount: "Amount",
    DepositAmountInsufficient: "Deposit amount is insufficient",
    DepositBank: "Deposit Bank",
    DepositDetails: "Deposit Details",
    DepositError: "An Issue Has Occur When Adding Deposit Details",
    DepositType: "Deposit Type",
    DepositToWallet: 'Deposit To Wallet',
    DepositorName: 'Depositor Name',
    WithdrawFromWallet: 'Withdraw From Wallet',
    WithdrawalOptions: "Withdrawal Options",
    CryptoAddress: "Crypto Address",
    CryptoAddressRequired: "Please Enter Crypto Address",
    CryptoChannelRequired: "Please Select Crypto Channel",
    Download: "Download",
    Desktop: "Desktop",
    EGames: "EGames",
    Earned: "Earned ($)",
    Email: "Email",
    EmailOrMobileNo: "Email Or Mobile No",
    EmailOrMobileNotFound: "Mobile number is required",
    SendCode: "Request Code",
    ResetPassVerificationCodeTitle: "A verification code had been sent to your registered mobile number",
    VerificationCode: "Verification Code",
    DidNotReceiveCode: "Did not receive the code?",
    ALERT_INVALID_OTP: "Invalid code. Please enter the correct code or contact us for assistance",
    ALERT_OTP_TIMEOUT: "Code expired. Please click 'Resend' to get a new code.",
    EnterVerificationCode: "Please enter your verification code. (Code will SMS to your registered phone number",
    EnterVerificationCodeWhatsApp: "Please enter your verification code. (Code will WhatsApp to your registered phone number",
    EnterVerificationCodeCustom1: "Verification code will be sent to your registered mobile number",
    EnterVerificationCodeCustom2: "shortly. Kindly contact us via Live Chat if you do not receive it within 5 minutes.",
    Euro2020: "Euro 2020",
    WorldCup: 'World Cup ' + currentYear,
    Error_NotSupportedCurrency: "Currency Not Supported",
    Error_OnlySupportAndroid: "SUPPORT ANDROID ONLY",
    ExtraBonus: "Extra Bonus",
    EWallet: "E-Wallet",
    FirstName: "Full Name",
    FishHuntKing: "Fish Hunt",
    ForgetPassword: "Please contact our 24 Hours online customer service.",
    ForgotPassword: "Forgot Password",
    ForgotUserOrPassword: "Forgot username or password",
    ForgotPasswordTitle: "Forgot password? Please enter your registered mobile number to reset your password.",
    FreeRegistration: "Free Registration",
    Games: "Games",
    Hi: 'Hi',
    History: "History",
    Here: 'Here',
    Home: "Home",
    HomeTeam: "Home",
    AwayTeam: "Away",
    IDD: "ID",
    DocInfo: 'Document Information',
    Doc1: 'Document 1',
    Doc2: 'Document 2',
    Doc3: 'Document 3',
    Internet: "Internet Banking",
    InvalidAmountSubmit: "The Amount Must Be Valid",
    JoinNow: "Join Now",
    Join: "Join",
    Tournament: 'Tournament',
    LAST_PACKAGE_NOT_711_PACKAGE: "Your last deposit Bonus Package is disallow for 7/11 Games. <a onclick='liveChatInc.openLiveChat(event);' tabindex='0' href='#' target='_self' style='color:#bd1b20;cursor:pointer'>Please contact us.</a>",
    PACKAGE_IS_BLOCKED: "Package is unavailable. <a onclick='parent.LC_API.open_chat_window({ source: `minimized` });return false' style='color:#bd1b20;cursor: pointer'>Please contact us.</a>",
    RPALERT_MIN_WITHDRAWAL_AMT_DEPOSIT_PACKAGE: 'Minimum withdrawal amount [REPLACEVALUE] not reach depend on last deposit package',
    RPALERT_InvalidShare1: 'Invalid Share.Agent Share Gap Unit Is 5 .',
    RPALERT_InvalidShare2: 'Invalid Share.Agent Share Must More Than 0 .',
    LiveCasino: "Live Casino",
    Casino: "Casino",
    LoginFailed: "Login Failed",
    LiveChat: "Live Chat",
    ChatNow: "Chat Now",
    Loading: "loading...",
    Login: "Login",
    LoginToDeposit: "Login",
    Logout: "Logout",
    Lottery: "Keno",
    Lottery2: "Lottery",
    VRLottery: "VR Lottery",
    MainWallet: "Main Wallet",
    MaxPerDayBonusExceeded: "Max per day bonus has been exceeded for the selected package, please select other package.",
    MaxWithdrawalPerDayExceed: "Maximum withdrawal times per day exceeded",
    MaxWithdrawalAmountExceeded: "Maximum withdrawal amount is Exceeded",
    MinimumDeposit: "Minimum Deposit [REPLACEVALUE1]",
    MinDeposit: "Min Deposit",
    MaxDeposit: "Max Deposit",
    MinWithdrawal: "Minimum Withdrawal",
    MinWithdrawalAmountInsufficient: "Minimum withdrawal amount is insufficient",
    MobileBanking: "Mobile Banking",
    MobileNo: "Mobile No",
    More: "More",
    Movie: "Movie",
    Games711: '7/11 Games',
    MultiLoginSignOut: "You have been signed out due to multiple logins. Please sign in again.",
    MyAccount: 'My Account',
    Membership: "Membership",
    NAME: "Name",
    NUMBER: "Number",
    NUMBERS: " numbers",
    NoBankFound: "Please Select a Bank",
    News: 'News',
    Next: 'Next',
    Notice: 'Notice',
    NoteTfs: 'Note: Main Wallet (Seamless)= Sexy Baccarat / SBO Sport / SBO Casino / PragmaticPlay / SBO Game / CQ9 / RTG / FlowGaming / BigGaming / Red Tiger / PGSoft/ WM / Jili / KingMaker / Ludo / JDB / GD4D',
    Not_Approved: "Rejected",
    OK: "OK",
    Yes: "Yes",
    OneStopGames: 'One Stop Games',
    OnlinePayment: "Online Payment",
    PaymentSuccess: {
        title: "Payment Confirmed",
        desc1: "Your Transaction Was Successful!",
        desc2: "Any inquiries, please contact us. We are here to help!"
    },
    OnlineBanking: "Online Banking",
    Ewallet: "E-Wallet",
    OpeningBalance: "Opening Balance",
    Sportbooks: 'Sportbooks',
    PBalance: "PointBalance",
    WPBalance: "WinPoint Balance",
    Freespin: "FreeSpin",
    Other: "Other",
    PBonus: "Bonus",
    PMax: "Max ($)",
    PTimes: "Times(x)",
    Package: "Package",
    Password: "Password",
    Pending: "Pending",
    ResetPassword: "Reset Password",
    RenewPassword: "Renew Password",
    Placeholder_UserName: 'Username',
    Placeholder_Password: 'Password',
    Placeholder_ConfirmPassword: 'Confirm Password',
    Placeholder_FullName: 'Full Name',
    Placeholder_Email: 'Email',
    Placeholder_ContactNumber: 'Mobile No',
    Placeholder_DOB: 'Birthday',
    Play: "Play",
    PlayNow: "Play Now",
    TrendingNow: "Trending Now",
    TryAgain: "Try Again",
    PlayNowMobile: "Play Now (Mobile)",
    PlayNowAGEGame: "Play (AG Slot)",
    PlayNowAGXIN: "Play (AG XIN)",
    PlayNowSBOSport: "Play (SBO Sport)",
    PlayNowSBOLCGame: "Play (SBO LC)",
    PlayNowSBOPragmatic: "Play (Pragmatic)",
    PlayNowSBOCQ9: "Play (CQ9)",
    PlayNowSBORTG: "Play (RTG)",
    PlayNowSBOFlowGaming: "Play (Flow Gaming)",
    PlayNowSBOGame: "Play (SBO Game)",
    PlayNowFGNetent: "Play (Netent)",
    PlayNowFGKiron: "Play (Kiron)",
    PlayNowFGMicroGaming: "Play (MicroGaming)",
    PlayNowFGPlayNGo: "Play (PlayNGo)",
    PlayNowFGQuickSpin: "Play (QuickSpin)",
    PlayNowBGLC: "Play (BigGaming LC)",
    PlayNowMGLC: "Play (MG LC)",
    PlayNowBGEG: "Play (BigGaming EG)",
    PlayNowMGEG: "Play (MG EG)",
    PlayerInfo: "Player Info",
    PleaseContactUs: "Please contact us.",
    PleaseLoginIn: "Please Login",
    PleaseSelect: "Please Select",
    PlayTech: 'PlayTech',
    ProgressiveJackpot: "Progressive Jackpot",
    Promotion: "Promotion",
    Promotions: 'Promotions',
    PromotionDetail: "Promotion Detail",
    RPALERT1_INVALID_GAME_PARAM: "Invalid Game Param",
    RPALERT1_INVALID_TRANSFER_AMOUNT: "Invalid Amount",
    RPALERT1_MAX_TRANSFER_AMOUNT: "Amount Must Be Equal Or Less Than Current Balance",
    RPALERT1_MIN_TRANSFER_AMOUNT: "Amount Must Be Greater Than 0",
    RPALERT1_ONLY_FOR_MYR: "Only For MYR Currency Code",
    RPALERT1_UNKNOWN_ERROR: "Check your internet connection and make sure the image size is small. If issue persistent please contact customer support.",
    RPALERT1_USERGAME_DISABLED: "User Game Disabled",
    RPALERT2_ACCOUNT_SUSPEND: "Sorry, Account Is Suspend",
    RPALERT2_PAYMENT_NOTAVAILABLE: "This Promotion Package Is Not Available For This Payment Method.",
    RPALERT2_BANK_BRANCH_EMPTY: "Please Key In State And City",
    RPALERT2_IMG_FILE_UNSUPPORTTED: "Selected image file is not supported, please attach image file with jpg / png / gif format.",
    RPALERT2_IMG_NOTSUPPORTSYMBOL: "Symbol Not Supported `~!@#$%^&*();:'\"<>//][]",
    RPALERT2_IMG_SAVE_Error: "Save Image Error",
    RPALERT2_IMG_SIZE_EXCEEDED: "Image Size Max Supported 3MB Only",
    RPALERT2_IMG_TYPE: "Only PNG, GIF and JPG Supported",
    RPALERT1_ACCOUNT_INACTIVE: "Account Inactive",
    RPALERT1_NO_ACCOUNT: 'No Account ID',
    RPALERT1_ACCOUNT_SUSPEND: "Account Suspend",
    RPALERT1_AMOUNT_IS_DECIMAL: "Decimal Amount Not Allow",
    RPALERT1_AMOUNT_IS_GREATER_THAN_CREDIT: "Insufficient Credit",
    RPALERT1_CANNOT_TRANSFER_SAME_PLATFORM: "Cannot transfer within the same product platform",
    RPALERT1_FAILED: "Failed",
    RPALERT1_GAMEDISABLED: "Game Disabled",
    RPALERT1_INSUFFICIENT_AMOUNT: "Balance not enough",
    RPALERT3_INTERNAL_ERROR: "Internal Server Down",
    RPALERT1_INVALID_AMOUNT: "Invalid amount",
    RPALERT1_NOT_NUMERIC_AMOUNT: "Amount is not numeric",
    RPALERT1_NO_AMOUNT: "Please key in amount to transfer.",
    RPALERT1_NO_CREDIT: "No Credit.",
    RPALERT1_NO_PLATFORM: "Please select product platform to transfer.",
    RPALERT1_NULL_AMOUNT: "Amount is null",
    RPALERT1_SUCCESS: "Success",
    RPALERT1_SYSTEM_BUSY: "Server Busy. Please Try Again Later. Thanks",
    RPALERT1_TRANSFER_FAIL: "Transfer fail",
    RPALERT1_LOTTERY_PRIZE_WITHDRAWAL: 'You have won in lottery, Please contact us in livechat',
    RPALERT5_BankNoMandatory: "Please enter bank no",
    RPALERT5_BankNoMinLength: "Bank No must consist at least ",
    RPALERT5_BSBNoMandatory: "Please enter bsb no",
    RPALERT5_PayIDMandatory: "Please enter pay id",
    RPALERT5_CurrencyReq: "Please select a currency",
    RPALERT5_EmailInvalid: "Please enter a valid email address",
    RPALERT5_EmailIsntRegister: "Email address isn't registered!",
    RPALERT5_EmailExist: "The email had been used. Please entry an unique email address",
    RPALERT5_MobileMinLength: "Mobile number must consist at least ",
    RPALERT5_SMSVerificationMandatory: "Please key in verify code.",
    RPALERT5_SMSVerificationNumberOnly: "Only number is required",
    RPALERT_MIN_AMOUNT_1000: 'Minimum amount must be at least [AMOUNT]',
    RPALERT5_BankAccountNumericOnly: 'Account number only accept numeric',
    RPALERT_FIRSTNAME_MIN_LENGTH: "Minimum length must be at least 3",
    RPALERT_FULLNAME_MANDOTARY: "Mandatory full name",
    RPALERT7_InvalidAccountLevel: "Invalid Account Level",
    RPALERT_CAPTCHA: "Invalid Captcha.",
    RPALERT_USERID_OR_PASSWORD_INVALID: "Invalid Username or Password",
    RPALERT7_MobileNoReq: "Mandatory mobile no",
    RPALERT_SUPPORT_ANDROID_ONLY: "Only Support Android",
    RPALERT5_PasswordMinLength: "Password length must be at least 6",
    RPALERT5_PasswordNotMatch: "Password is not matched",
    RPALERT5_PasswordAlphaNumericOnly: 'Password must contain letters and numbers only with 6 to 12 length',
    RPALERT_Password_REPEAT: 'You’ve already used this password. Please choose a different one.',
    RPALERT_MOBILE_DUPLICATE: 'Mobile number link with multiple account. Please contact our 24 Hours online customer service.',
    RPALERT_MOBILE_EXIST: 'Mobile number not available.',
    RPALERT_BANKACCNO_EXIST_DUE_TO_OTHER_ACC: 'Bank account exist in old account [REPLACEVALUE]. Please contact customer support.',
    RPALERT_ENTER_CAPTCHA: "Please enter captcha",
    RPALERT_ENTER_PASSWORD: "Please enter password",
    RPALERT_ENTER_CONFIRMPASSWORD: "Please enter password again",
    RPALERT_ENTER_NAME: "Please enter your desired username",
    RPALERT7_ProductUnvailable: "Product Not Supported",
    RPALERT_PACKAGE_NOT_FOUND: "Package doesn't exist",
    RPALERT_PACKAGE_NOT_SELECTED: 'Please Select Any Bonus Package',
    RPALERT7_RegisterFail: "Registration Failed",
    RPALERT_USER_ID: 'Username must be letters and numbers only',
    RPALERT5_UsernameExistedMsg1: "Please consider following：",
    RPALERT5_LoginnameExisted: 'Login name already registered!',
    RPALERT5_LoginnameExisted1: 'Please choose another one',
    RPALERT_SocialIDValid: 'Invalid Social ID',
    RPALERT_USERID_MANDATORY: "Mandatory Username",
    RPALERT_USERID_MIN_LENGTH: "Minimum length must be at least 6",
    RPALERT5_UsernameMaxLength: 'Maximum length exceeded.',
    RPALERT7_UsernamePasswordCannotSame: "Username and Password cannot be same",
    RPALERT_VERIFICATIONFAILED: "Please key in the valid verification code.",
    RPALERT_VERIFICATIONSMSLOCKED: "Your account is locked. Please contact customer service or livechat with us",
    RPALERT_WALLET_LOCK: 'Your deposit package is unavailable for this product.',
    RPALERT_INVALID_AFFILIATEID: 'Invalid Affiliate',
    RPALERT_PAYMENT_GATEWAY_DISABLE: "Payment Gateway Disabled.",
    RPALERT_SUPPORT_PC_ONLY: "Sorry, For Now Only Support PC. Stay Tuned.",
    RPAlert_MinWithdrawal: "Min. Amount ",
    RPAlert_MaxWithdrawal: "Max. Amount ",
    CreditTransfer: "Credit Transfer",
    CreditTransferTo: "Credit Transfer To",
    RPLocalGames: "Local Games",
    RPMemberSettings: "Comfirm Settings?",
    RPPTNT_LOGIN: "Only Support Android",
    RPPTNT_LOGIN2: "Good Luck To You",
    RPPTNT_LOGIN3: "Please login with PlayTech App",
    RPPTNT_LOGIN31: "Please login with 918Kiss App",
    RPPTNT_LOGIN4: "Login ID : ",
    Wallet: "Wallet",
    MyWallet: "Wallet",
    ReceiptNo: "Receipt No",
    RPALERT_REF_NUMBER_INVALID: 'Reference number invalid. May only contain letters, numbers and [-] symbol',
    RefNumber: "Reference Number",
    Refresh: "Refresh",
    RegisterDate: "Registered Date",
    RegisterNow: "Register Now",
    RegistrationNotice: "Tips: In order to regulate gaming site account management, every member allows only registered a game account, please fill in your real name, withdrawals shall be binding and consistent registered name bank card operation, thank you for your cooperation.",
    RegistrationNotice2: "Click the Submit button below, you confirm that you are over 18 years old.",
    RememberMe: "Remember Me",
    RollOverTarget: "Turnover / Target",
    TurnoverAchieved: "Turnover Achieved",
    TurnoverTarget: "Turnover Target",
    TurnoverStatus: "Turnover Status",
    Progress: "Progress",
    RolloverIncompleteTitle: "Rollover incomplete.",
    RolloverIncompleteDesc: "Your turnover is below the required target.",
    RemainingToUnlockWithdrawal: "remaining to unlock withdrawal",
    SCR888Games: "918Kiss Games",
    Special: 'Special',
    SCRGames: "7-11 Games",
    HOTGames: "New Hot Games",
    HotGames: "Hot Games",
    STATE: "State",
    Status: "Status",
    SessionTimeout: "Session Timeout",
    Set: "Set",
    Settings: "Settings",
    AccSettings: "Acc Settings",
    SignIn: "Sign In",
    SlotGames: "Slot Games",
    SlotEGames: "Slot EGames",
    SlotMachine: "Slot Machine",
    Slots: "Slots",
    Slot: "Slot",
    PleaseSelHowKnowUs: 'How do you know us',
    SocialMedia: 'Social Media',
    SocialID: 'Social ID',
    SlotMachinesGames: 'Slot Machines Games',
    LiveCasinoGames: 'Live Casino Games',
    Sport: 'Sport',
    Sportsbook: 'Sportsbook',
    Sports: 'Sports',
    Cricket: 'Cricket',
    SpadeGames: 'SpadeGames',
    Poker: "Poker",
    Statement: "Statement",
    SocialLink: 'Social Link',
    Submit: "Submit",
    Successful: "Successful",
    TYPE: "Type",
    TableGames: "Table Games",
    TermsAndConditions: "Terms & Conditions",
    Topup: "Topup",
    bankfees: "Bank Fee",
    TNC: 'T & C',
    Total: "Total ($)",
    TotalDownline: "Total Downline",
    TotalDownlineWin: "Total Win",
    TotalDownlineLose: "Total Lose",
    TotalDownlineCommission: "Total Commission",
    Transaction: "Daily Transaction Report",
    TransactionType: "Transaction Type",
    Transfer: "Transfer",
    TransferAmount: "Transfer Amount",
    TransferDateTimeInvalid: "Please select a DateTime",
    TransferNotice: "Please Select A Transfer Type",
    TransferToMSport: "Transfer <-> Wallet",
    TransferToRPEGames: "Transfer <-> Wallet",
    TransferType: "TRANSFER TYPE",
    UnderMaintenance: "Under Maintenance",
    Upload: "Upload",
    UserIdIsNull: "Member Does Not Exist",
    UserName: "Username",
    Username: "Username",
    VE_BankAccountNotAvailable: "Bank account not available",
    RPALERT5_MandatoryBankAccount: "Mandatory Bank Account",
    ValidDownline: "Valid Downline",
    ValidLose: "Valid Lose($)",
    ValidWin: "Valid Win($)",
    VideoPoker: "Video Poker",
    Welcome: "Welcome",
    Withdraw: "Withdraw",
    WithdrawAll: "Withdraw All",
    WithdrawAllCreditToMainWallet: "Withdraw All Credit To Main Wallet",
    Withdrawal: "Withdrawal",
    WithdrawalError: "An Issue Has Occur When Adding Withdrawal Details",
    WithdrawalLimit: "Valid Withdraw Amount 100.00 ~200000.00",
    WithdrawalTnC: "*Daily withdraw count is 3 times, if exceed daily withdraw count, you will need to pay 3% processing fee.",
    WrongAccountOrPassword: "Wrong Account Or Password",
    YourAccountBalance: "Your Account Balance",
    accountID: "Account ID :",
    bankIdNotValid: "No Bank Recognized",
    bankUserNameIsEmpty: "No Bank User Name",
    cashbalance: "Cash Balance: ",
    FBLogin: "Facebook Login",
    From: "From",
    imgAGFishHunt: "/Content/images/fishhunt_ag_en.png?v1",
    imgAgDeluxe: "/Content/images/AGDeluxeSuite_FA_en.jpg?v1",
    imgAllBetDeluxe: "/Content/images/AllBet_en.jpg?v1",
    imgXPGLC: "/Content/images/XPGLiveCasino_en.jpg",
    imgBetSoftEG: "/Content/images/BetSoftSlot_en.jpg",
    imgSALC: "/Content/images/SALiveCasino_en.jpg?v1",
    imgSAEG: "/Content/images/SASlot_en.jpg?v1",
    imgCockFight: "/Content/images/CockFight_en.jpg?v3",
    imgGDDeluxe: "/Content/images/GoldDeluxe_en.jpg?v3",
    imgPTFishHunt: "/Content/images/fishhunt_pt_en.png?v3",
    imgPlayTech: "/Content/images/PlaytechLiveCasino_FA_en.jpg?v3",
    imgPtGame: "/Content/images/PlaytechSlot_FA.jpg?v3",
    imgRTDeluxe: "/Content/images/RedTiger_en.jpg?v3",
    imgSBDeluxe: "/Content/images/Sunbet_en.jpg?v3",
    imgShiShiCai: "/Content/images/shishicai_en.png",
    imgSrcAGEGame: "/Content/images/AGXinGame_en.jpg?v3",
    imgSrcGame: "/Content/images/SCR888Slot_FA.jpg",
    imgSrcSpageGames: "/Content/images/SpadeGames_en.jpg",
    LoginID: "Login ID",
    loginname: "Login Name: ",
    SEVEN11_NOTE: 'Note* If transfer rejected could be due to BONUS PACKAGE selected is disallow for 711 platform (918Kiss, Playboy, 3win8, Joker). ',
    RPALERT_PACKAGE_APPROVAL_EXIST: "There's a pending request package",
    VOUCHER_PENDING_DEPOSIT_EXIST: "Please wait until your pending deposit request is approved before redeeming this voucher.",
    VOUCHER_PENDING_WITHDRAWAL_EXIST: "Please wait until your pending withdrawal request is approved before redeeming this voucher.",
    VOUCHER_ALREADY_CLAIMED: "This voucher has already been redeemed.",
    VOUCHER_UNAVAILABLE: "This voucher is not available for redemption.",
    VOUCHER_EXPIRED: "This voucher has expired.",
    RPALERT_PACKAGE_NEED_DEPOSIT: "Please deposit before withdraw. Thanks",
    RPALERT_RECEIPT_NO_EMPTY: "Please fill up ref number",
    RPALERT_RECEIPT_NOT_FOUND: "Please upload receipt",
    To: "To",
    RPALERT_TRAN_DATE_NULL: "No Transfer Date Selected",
    RPALERT_ROLLOVER_LESS_THAN_TARGET_AMOUNT: "Rollover is less than the targeted amount",
    RPALERT_WITHDRAW_AMT_EXCESS: "Withdrawal amount exceeds your available balance",
    RPALERT_WITHDRAWAL_VENDOR_FAILED: "Withdrawal from vendor failed. Please try again later",
    P2PRolloverNotMeet: '* Rollover Not Meet cannot perform P2P Transfer',
    ViewDesktopVersion: 'View Desktop Version',
    DesktopVersion: 'Desktop Version',
    VIP: 'VIP',
    Keno: 'Keno',
    VIPPDFDownload: 'DOWNLOAD OUR VIP BROCHURE',
    AffProgramPDFDownload: 'DOWNLOAD OUR AFFILIATE BROCHURE',
    BankTransfer: 'Bank Transfer',
    SportsbookLX: 'Sportbook',
    LiveCasinoLX: 'LiveCasino',
    EGamesLX: 'EGame',
    LotteryLX: ' Lottery',
    MoreLX: 'More',
    MobileLX: 'Mobile',
    Facebook: "Facebook",
    Instagram: "Instagram",
    Forum: "Forum",
    GoogleSearch: "Google Search",
    UserNameEmail: 'Username / Email',
    PleaseEnterUsernameEmail: 'Please enter either Username or Email',
    RPALERT4_ResetPassFail: 'Reset Password Fail. Please try again',
    RPALERT4_ResetPassSuccess: 'Reset Password Successful',
    ALERT_ResetPassSuccessMobileNotice: 'Your new password has been sent to your registered mobile number.',
    ALERT_ResetPassSuccessEmailNotice: 'Your new password has been sent to your registered email.',
    ALERT_ResetPassSuccessMobileNEmailNotice: 'Your new password has been sent to your registered mobile number or email.',
    RPALERT4_RenewPassSuccess: 'Renew Password Successful',
    ALERT_RenewPassSuccessMobileNotice: 'Your new password has been sent to your registered mobile number. If your registered mobile number is not active or you did not receive the new password, please contact our live chat agent for immediate assistance.',
    MemberRegistration: 'Member Registration',
    RegisterMandatoryInfo: 'All Information is required',
    AccountInformation: 'Account Information',
    UserNotFound: 'User not found, Please enter your registered mobile number',
    Rated: 'Rated',
    BasedOn: 'based on',
    Reviews: 'reviews',
    PoweredBy: 'Powered By',
    WithdrawalName: '(Same as withdrawal bank account.)',
    upegcom: "Upline EGamesCom",
    uplccom: "Upline LiveCasinoCom",
    upftcom: "Upline FightCom",
    upllcom: "Upline LotteryCom",
    LUDOBET: "LUDO",
    LiveStream: "Live Stream",
    LiveStreamWatchLive: "Watch Live",
    LiveStreamNotStreaming: "Not Streaming",
    LiveStreamSearchPlaceholder: "Search team or league...",
    LiveStreamNoMatches: "No matches found for the selected filters.",
    LiveStreamLoadFailed: "Unable to load matches. Please try again.",
    LiveStreamUnavailable: "This match is no longer streaming. Please refresh the list.",
    LiveStreamMatchCount: "[REPLACEVALUE1] matches",
    LiveStreamToday: "Today",
    LiveStreamLive: "LIVE",
    COCKFIGHT: "COCKFIGHT",
};
if (window.companyInfo && (window.companyInfo.id == 1755 || window.companyInfo.id == 1816)) {
    en.Placeholder_FullName = 'Full Name Match Bank Account Holder';
}
if (window.companyInfo && window.companyInfo.id == 433) {
    en.Placeholder_UserName = 'An Unique Username';
    en.Placeholder_Password = 'Password With At Least 6 Characters';
    en.Placeholder_ConfirmPassword = 'Confirm Password';
    en.Placeholder_FullName = 'Full Name Match Bank Acc Holder For Withdrawal';
    en.Placeholder_Email = 'Valid Email Address (example@domain.com)';
    en.Placeholder_ContactNumber = '(Maximum 13 Digits Including 60)';
    en.Package = 'Promotion';
    en.LoginToDeposit = 'Login To Deposit';
    en.GameUploadSlider.TopSlotTitle = 'Today’s Lucky Last 3 Digits – HP Number';
    en.GameUploadSlider.TopCasinoTitle = 'Hottest Winning Game Now';
    en.DocInfo = 'KYC Submission',
        en.Doc1 = 'ID Card / Passport image',
        en.Doc2 = 'Driving License',
        en.Doc3 = 'Selfie Photo';
    en.YoutubeVideos = "Marketing Video";
}
if (window.companyInfo && window.companyInfo.id == 1700) {
    en.S88Pay = en.Deposit;
}
if (window.companyInfo && (window.companyInfo.id == 511 || window.companyInfo.id == 732)) {
    en.Join = 'Register';
    en.JoinNow = 'Register';
}
if (window.companyInfo && (window.companyInfo.id == 433)) {
    en.RPALERT_MOBILE_EXIST = 'Phone number already registered. Please contact Live Chat Or Customer Services.';
    en.RPALERT5_EmailExist = 'Email already registered. Please contact Live Chat Or Customer Services.';
    en.Register = 'Register';
    en.ForgotPassword = en.ForgotUserOrPassword;
}
if (window.companyInfo && (window.companyInfo.id == 1438 || window.companyInfo.id == 1439)) {
    en.Sportsbook = "Sports";
    en.LiveCasino = "Casino";
    en.Lottery = "Lottery";
    en.Keno = "Lottery";
    en.More = "Fishing";
}
if (window.companyInfo && window.companyInfo.id == 1696) {
    en.AccountNumber = "Pay ID";
}
if (window.companyInfo && window.companyInfo.id == 1628) {
    en.More = "3D Games";
    en.SCRGames = "7-11";
}
if (window.companyInfo && window.companyInfo.id == 1660) {
    en.GameProviderTitle.DG855 = "DG855";
}
if (window.companyInfo && (window.companyInfo.id == 1666)) {
    en.RPALERT_MOBILE_EXIST = 'Mobile number has been registered';
}
if (window.companyInfo && window.companyInfo.id == 1685) {
    en.RefNumber = "Transaction ID";
    en.WithdrawAll = "Restore Wallet";
    en.LUDOBET = "LUDO";
}
if (window.companyInfo && window.companyInfo.id == 1672) {
    en.Casino = "Live";
}
if (window.companyInfo && window.companyInfo.id == 1707) {
    en.RefNumber = "Reference Number/Transaction ID";
    en.WithdrawAll = "Restore Wallet";
    en.LUDOBET = "LUDO";
}
if (window.companyInfo && window.companyInfo.id == 1661) {
    en.Placeholder_UserName = "Phone Number";
}
if (window.companyInfo && window.companyInfo.id == 1787) {
    en.RefNumber = "Reference Number/Transaction ID";
}
if (window.companyInfo && (window.companyInfo.id == 732 || window.companyInfo.id == 1725 || window.companyInfo.id == 1766)) {
    en.MyBonus = "My Commission";
}
if (window.companyInfo && window.companyInfo.id == 1681) {
    en.RefNumber = "Player ID";
}
if (window.companyInfo && window.companyInfo.id == 433) {
    en.VerificationCode = "Verification OTP code";
    en.EnterVerificationCode = "Please enter your verification code (Sent via WhatsApp / SMS to your registered phone number -";
    en.EnterVerificationCodeWhatsApp = "Please enter your verification code (Sent via WhatsApp / SMS to your registered phone number -";
}
